import React from 'react';
import './ContactNumbers.css';

const ContactNumbers = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Contact Numbers',
        subtitle: 'Reach out to us for consultations and guidance',
        appointmentBooking: 'Appointment Booking',
        appointmentDesc: 'Call for consultation appointments',
        callNow: 'Call Now',
        gpayPayments: 'GPay & Digital Payments',
        gpayDesc: 'Send payments via GPay/UPI'
      },
      hi: {
        title: 'संपर्क नंबर',
        subtitle: 'परामर्श और मार्गदर्शन के लिए हमसे संपर्क करें',
        appointmentBooking: 'अपॉइंटमेंट बुकिंग',
        appointmentDesc: 'परामर्श अपॉइंटमेंट के लिए कॉल करें',
        callNow: 'अभी कॉल करें',
        gpayPayments: 'GPay और डिजिटल भुगतान',
        gpayDesc: 'GPay/UPI के माध्यम से भुगतान भेजें'
      },
      gu: {
        title: 'સંપર્ક નંબરો',
        subtitle: 'સલાહ અને માર્ગદર્શન માટે અમારો સંપર્ક કરો',
        appointmentBooking: 'એપોઇન્ટમેન્ટ બુકિંગ',
        appointmentDesc: 'સલાહ એપોઇન્ટમેન્ટ માટે કૉલ કરો',
        callNow: 'હવે કૉલ કરો',
        gpayPayments: 'GPay અને ડિજિટલ પેમેન્ટ',
        gpayDesc: 'GPay/UPI દ્વારા પેમેન્ટ મોકલો'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  return (
    <section id="contact-numbers" className="contact-numbers">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{getTranslation('title')}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">{getTranslation('subtitle')}</p>
        </div>
        <div className="contact-numbers-grid">
          <div className="contact-number-card">
            <div className="contact-icon">
              <i className="fas fa-calendar-check"></i>
            </div>
            <h3>{getTranslation('appointmentBooking')}</h3>
            <div className="contact-number">
              <a href="tel:+918160569755">+91 8160569755</a>
            </div>
            <p>{getTranslation('appointmentDesc')}</p>
            <div className="contact-actions">
              <a href="tel:+918160569755" className="contact-action-btn call-btn">
                <i className="fas fa-phone"></i>
                <span>{getTranslation('callNow')}</span>
              </a>
              <a href="https://wa.me/918160569755?text=Hello%20Ankit%20Raval,%0A%0AI%20would%20like%20to%20book%20an%20appointment%20for%20consultation.%0A%0APlease%20let%20me%20know%20your%20available%20time%20slots.%0A%0AThank%20you!" className="contact-action-btn whatsapp-btn" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
          <div className="contact-number-card">
            <div className="contact-icon">
              <i className="fas fa-mobile-alt"></i>
            </div>
            <h3>{getTranslation('gpayPayments')}</h3>
            <div className="contact-number">
              <a href="tel:+919426708100">+91 9426708100</a>
            </div>
            <p>{getTranslation('gpayDesc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactNumbers;